import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { adminAddMerchantAccount, adminDeleteAccount, adminUpdatePassword, searchUsers } from "../../../services/users";
import PageSelector from '../../../components/PageSelector';
import LoadingPage from "../../../components/Loading";
import DropdownMenu from '../../../components/DropdownMenu'
import { approveRefund, fetchRefundById, fetchReunds, rejectRefund, updateRefund } from "../../../services/refunds";

const limit = 20
function Page(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)


    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem / limit) || 1
    const [data, setData] = useState([])
    const page = parseInt(searchParams.get('page')) || 1
    const filterLastname = searchParams.get('lastname')
    const filterFirstname = searchParams.get('firstname')
    const filterEmail = searchParams.get('email')
    const filterType = searchParams.get('type')||'全部'
    const { id } = useParams();
    //
    const handleSearchLastname = (e) => { setSearchParams({ page: 1, lastname: e.target.value }) }
    const handleSearchFirstname = (e) => { setSearchParams({ page: 1, firstname: e.target.value }) }
    const handleSearchEmail = (e) => { setSearchParams({ page: 1, email: e.target.value }) }
    useEffect(() => {
        if (!props.token.isLogin) return
        const timer = setTimeout(fetchData, 500)
        const intervel = setInterval(fetchData, 10000)
        return () => {
            clearTimeout(timer)
            clearInterval(intervel)
        }
    }, [searchParams, props.token])
    async function fetchData() {
        // formatDataForChart()
        const filter = { partnerId: id }
        if(filterType === '待處理') filter.status = 'PENDING'
        else if(filterType === '處理中') filter.status = 'PROCESSING'
        else if(filterType === '已拒絕') filter.status = 'REJECTED'
        else if(filterType === '已取消') filter.status = 'CANCELED'
        else if(filterType === '已退款') filter.status = 'REFUNDED'
        else if(filterType === '錯誤') filter.status = 'ERROR'

        // if (filterLastname) filter['data.lastname'] = { "$regex": filterLastname, "$options": 'i' }
        // if (filterFirstname) filter['data.firstname'] = { "$regex": filterFirstname, "$options": 'i' }
        // if (filterEmail) filter['email'] = { "$regex": filterEmail, "$options": 'i' }
        const res = await fetchReunds(props.token.token, filter, { limit, skip: limit * (page - 1), sort: { _id: -1 } })
        if (res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage = (p) => () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    
    const [isViewingRefund, setIsViewingRefund] = useState(false)
    const handleViewRefund = (id) => async () => {
        let result = await fetchRefundById(props.token.token, id)
        if (result.errno) {
            alert(result.message || '無法獲取退款詳情')
            return 
        }
        setIsViewingRefund(result?.result||null)
    }
    const [isUpdatingRemarks, setIsUpdatingRemarks] = useState(false)
    const [newRemarks, setNewRemarks] = useState('')
    const handleStartEditRemarks = () => {
        if (!isViewingRefund) return
        setNewRemarks(isViewingRefund.remarks || '')
        setIsUpdatingRemarks(true)
    }
    const handleUpdateRemarks = async () => {
        setIsloading(true)
        let result = await updateRefund(props.token.token, isViewingRefund._id, { remarks: newRemarks })
        if (result.errno) {
            setIsloading(false)
            alert(result.message || '無法更新退款備註')
            return
        }
        setIsloading(false)
        setIsUpdatingRemarks(false)
        handleViewRefund(isViewingRefund._id)()
        fetchData()
    }
    const [isConfirmApprove, setIsConfirmApprove] = useState(false)
    const [isConfirmReject, setIsConfirmReject] = useState(false)
    const handleApproveRefund = async () => {
        if (!isViewingRefund) return
        if(isViewingRefund.status !== 'PENDING') {
            alert('此退款申請已經處理過，無法再次核准')
            return
        }
        setIsloading(true)
        let result = await approveRefund(props.token.token, isViewingRefund._id)
        if (result.errno) {
            alert(result.message || '無法核准退款')
            setIsloading(false)
            return
        }
        setIsloading(false)
        setIsConfirmApprove(false)
        handleViewRefund(isViewingRefund._id)()
        fetchData()
        
    }
    const handleRejectRefund = async () => {
        if (!isViewingRefund) return
        if(isViewingRefund.status !== 'PENDING') {
            alert('此退款申請已經處理過，無法再次拒絕')
            return
        }
        setIsloading(true)
        let result = await rejectRefund(props.token.token, isViewingRefund._id)
        if (result.errno) {
            alert(result.message || '無法拒絕退款')
            setIsloading(false)
            return
        }
        setIsloading(false)
        setIsConfirmReject(false)
        handleViewRefund(isViewingRefund._id)()
        fetchData()
    }
    function selectFilter(item,index){
        searchParams.delete('type')
        searchParams.set('type', item)
        setSearchParams(searchParams)
    }

    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden p-[16px]">
            <div className="w-full flex flex-row gap-[16px] flex-wrap items-center justify-start">
                {/* <input onChange={handleSearchLastname} placeholder="按姓氏搜尋" className="p-[4px] rounded-[4px]" />
                <input onChange={handleSearchFirstname} placeholder="按名字搜尋" className="p-[4px] rounded-[4px]" />
                <input onChange={handleSearchEmail} placeholder="透過電子郵件搜尋" className="p-[4px] rounded-[4px]" /> */}
                <div className="text-[#6E604C]">Filter By </div>
                <DropdownMenu value={filterType} select={selectFilter} options={['全部',
                    '待處理', '處理中', '已拒絕', '已取消', '已退款', '錯誤'
                ]} />
            </div>
            <div className="flex-1 w-full flex flex-col py-[16px]" style={{ overflowY: 'auto' }}>
                {/*Header */}
                <div className="flex flex-row justify-betwen items-center w-full text-[12px] text-[#6E604C] font-[700] pb-[8px]" style={{ borderBottom: '2px solid #6E604C' }}>
                    <div className='flex-[2]'>退款編號</div> 
                    <div className="flex-[2]">退款申請時間</div>
                    <div className="flex-[2]">退款狀態</div>
                    <div className="flex-[2]">退款金額</div>
                    <div className="flex-[2]">交易編號</div>
                    <div className="flex-[2]">退款原因</div>
                    <div className="flex-[2]">退款備註</div>
                    <div className="flex-1"></div>

                </div>

                <div className="flex-1 w-full flex flex-col mt-[16px]">
                    {data?.map((item, index) =>
                        <div key={item?._id} className="flex flex-row justify-betwen items-center w-full text-[12px] text-[black] font-[400] py-[8px]" style={{ borderBottom: '.5px solid #fff' }}>
                            <div className='flex-[2] text-[10px]'>{item?._id}</div> 
                            <div className="flex-[2]">{new Date(item?.createDate).toLocaleString()}</div>
                            <div className="flex-[2]">{
                            item?.status==='PENDING' ? '待處理' :
                            item?.status==='PROCESSING' ? '處理中' :
                            item?.status==='REJECTED' ? '已拒絕' :
                            item?.status==='CANCELED' ? '已取消' :
                            item?.status==='REFUNDED' ? '已退款' :
                            item?.status==='ERROR' ? '錯誤' :
                            '未知狀態'
                        }</div>
                            <div className="flex-[2]">{item?.amount}</div>
                            <div className="flex-[2] text-[10px]">{item?.transactionId}</div>
                            <div className="flex-[2]" style={{whiteSpace:'pre'}}>{item?.reason}</div>
                            <div className="flex-[2]" style={{whiteSpace:'pre'}}>{item?.remarks}</div>
                            <div className="flex-1 cursor-pointer text-[black] hover:text-[#473F3A] text-[12px] font-[600]" onClick={handleViewRefund(item?._id)}>
                                查看詳情
                            </div>
                        </div>
                    )}
                </div>
            </div>


            <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage} />

            {isViewingRefund &&
                <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000080] flex items-center justify-center z-[49]">
                    <div className="bg-white p-[16px] rounded-[8px] w-[90%] max-w-[600px] flex flex-col items-start">
                        <h2 className="text-[18px] font-bold mb-[16px] w-full text-center">退款詳情</h2>
                        <div className="mb-[8px]"><strong>退款編號:</strong> {isViewingRefund?._id}</div>
                        <div className="mb-[8px]"><strong>申請時間:</strong> {new Date(isViewingRefund?.createDate).toLocaleString()}</div>
                        <div className="mb-[8px]"><strong>退款狀態:</strong> {
                            isViewingRefund?.status==='PENDING' ? '待處理' :
                            isViewingRefund?.status==='PROCESSING' ? '處理中' :
                            isViewingRefund?.status==='REJECTED' ? '已拒絕' :
                            isViewingRefund?.status==='CANCELED' ? '已取消' :
                            isViewingRefund?.status==='REFUNDED' ? '已退款' :
                            isViewingRefund?.status==='ERROR' ? '錯誤' :
                            '未知狀態'
                        }</div>
                        <div className="mb-[8px]"><strong>交易類型:</strong> {isViewingRefund?.transaction?.type==='MONEY'?'HKD':isViewingRefund?.transaction?.type==='WECHAT'?'WeChat':'T.Dollars'}</div>
                        <div className="mb-[8px]"><strong>用戶:</strong> {isViewingRefund?.user?.data?.firstname} {isViewingRefund?.user?.data?.lastname} ({isViewingRefund?.user?.email||isViewingRefund?.user?.mobile})</div>
                        <div className="mb-[8px]"><strong>商品:</strong> {isViewingRefund?.product?.name} ({isViewingRefund?.product?._id})</div>
                        <div className="mb-[8px]"><strong>商品價格:</strong> {isViewingRefund?.product?.price} {isViewingRefund?.transaction?.type==='MONEY'?'HKD':isViewingRefund?.transaction?.type==='WECHAT'?'RMB':'T.Dollars'}</div>
                        <div className="mb-[8px]"><strong>商品數量:</strong> {isViewingRefund?.transaction?.products?.find((p) => p.productId === isViewingRefund?.productId)?.quantity}</div>
                        <div className="mb-[8px]"><strong>退款金額:</strong> {isViewingRefund?.amount} {isViewingRefund?.transaction?.type==='MONEY'?'HKD':isViewingRefund?.transaction?.type==='WECHAT'?'RMB':'T.Dollars'}</div>
                        <div className="mb-[8px]"><strong>商戶:</strong> {isViewingRefund?.product?.partnerName}</div>
                        <div className="mb-[8px]"><strong>原因:</strong> {isViewingRefund?.reason}</div>
                        <div className="mb-[8px]"><strong>交易編號:</strong> {isViewingRefund?.transactionId}</div>
                        <div className="mb-[8px]"><strong>交易時間:</strong> {new Date(isViewingRefund?.transaction?.createDate).toLocaleString()}</div>
                        <div className="mb-[8px]"><strong>交易狀態:</strong> {
                            isViewingRefund?.transaction?.status==='PENDING' ? '待處理' :
                            isViewingRefund?.transaction?.status==='PROCESSING' ? '處理中' :
                            isViewingRefund?.transaction?.status==='COMPLETED' ? '已完成' :
                            isViewingRefund?.transaction?.status==='ERROR' ? '錯誤' :
                            isViewingRefund?.transaction?.status==='REFUNDED' ? '已退款' :
                            '未知狀態'
                        }</div>
                        <div className="mb-[8px]"><strong>備註:</strong> {isViewingRefund?.remarks}</div>
                        { isViewingRefund?.error &&
                            <div className="mb-[8px] text-[red]"><strong>錯誤信息:</strong> {isViewingRefund?.error}</div>
                        }
                        <div className="w-full flex flex-row justify-end items-center gap-[4px]">
                            <button onClick={handleStartEditRemarks} className="mt-[16px] bg-[#888] text-white px-[16px] py-[8px] rounded">編輯備註</button>
                            {isViewingRefund.status==='PENDING'&&<button onClick={() => setIsConfirmApprove(true)} className="mt-[16px] bg-[#22aa20] text-white px-[16px] py-[8px] rounded">核准退款</button>}
                            {isViewingRefund.status==='PENDING'&&<button onClick={() => setIsConfirmReject(true)} className="mt-[16px] bg-[#ee2222] text-white px-[16px] py-[8px] rounded">拒絕退款</button>}
                            <button onClick={() => setIsViewingRefund(null)} className="mt-[16px] bg-[#6E604C] text-white px-[16px] py-[8px] rounded">關閉</button>
                        </div>
                    </div>
                </div>
            }
            {isUpdatingRemarks &&
                <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000080] flex items-center justify-center z-[50]">
                    <div className="bg-white p-[16px] rounded-[8px] w-[90%] max-w-[600px] flex flex-col items-start">
                        <h2 className="text-[18px] font-bold mb-[16px] w-full text-center">編輯退款備註</h2>
                        <textarea
                            className="w-full h-[100px] p-[8px] border border-[#ccc] rounded"
                            value={newRemarks || ''}
                            onChange={(e) => {
                                setNewRemarks(e.target.value)
                            }}
                        />
                        <div className="w-full flex flex-row justify-end items-center gap-[4px]">
                            <button onClick={() => setIsUpdatingRemarks(false)} className="mt-[16px] bg-[#888] text-white px-[16px] py-[8px] rounded">取消</button>
                            <button onClick={handleUpdateRemarks} className="mt-[16px] bg-[#6E604C] text-white px-[16px] py-[8px] rounded">儲存</button>
                        </div>
                    </div>
                </div>
            }
            {isConfirmApprove &&
                <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000080] flex items-center justify-center z-[50]">
                    <div className="bg-white p-[16px] rounded-[8px] w-[90%] max-w-[600px] flex flex-col items-start">
                        <h2 className="text-[18px] font-bold mb-[16px] w-full text-center">確認退款</h2>
                        <p className="mb-[16px]">您確定要核准此退款申請嗎？</p>
                        <div className="w-full flex flex-row justify-end items-center gap-[4px]">
                            <button onClick={() => setIsConfirmApprove(false)} className="mt-[16px] bg-[#888] text-white px-[16px] py-[8px] rounded">取消</button>
                            <button onClick={handleApproveRefund} className="mt-[16px] bg-[#22aa20] text-white px-[16px] py-[8px] rounded">核准退款</button>
                        </div>
                    </div>
                </div>
            }
            {isConfirmReject &&
                <div className="fixed top-0 left-0 right-0 bottom-0 bg-[#00000080] flex items-center justify-center z-[50]">
                    <div className="bg-white p-[16px] rounded-[8px] w-[90%] max-w-[600px] flex flex-col items-start">
                        <h2 className="text-[18px] font-bold mb-[16px] w-full text-center">確認拒絕退款</h2>
                        <p className="mb-[16px]">您確定要拒絕此退款申請嗎？</p>
                        <div className="w-full flex flex-row justify-end items-center gap-[4px]">
                            <button onClick={() => setIsConfirmReject(false)} className="mt-[16px] bg-[#888] text-white px-[16px] py-[8px] rounded">取消</button>
                            <button onClick={handleRejectRefund} className="mt-[16px] bg-[#ee2222] text-white px-[16px] py-[8px] rounded">拒絕退款</button>
                        </div>
                    </div>
                </div>  
            }
            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)


